<section class="cui-dialog confirmation-dialog">
  <header class="cui-dialog__header">
    <h1>{{ confirmData.confirmTitle }}</h1>
  </header>
  <div class="cui-dialog__content">
    <p>{{ confirmData.confirmMessage }}</p>
    @if (error()) {
      <p class="confirmation-error" role="alert">{{ error() }}</p>
    }
  </div>
  <footer class="cui-dialog__actions">
    <button cuiButton variant="plain" type="button" [disabled]="isLoading()" (click)="onCancel()">
      Cancel
    </button>
    <button
      cuiButton
      variant="primary"
      type="button"
      [disabled]="isLoading()"
      (click)="onConfirm()">
      {{ confirmData.confirmLabel || 'Confirm' }}
    </button>
  </footer>
</section>
